import styleConfig from '~/src/css/global.module.scss';

/**
 * All site areas
 */
export const SiteArea = {
    NEWS: 'siteAreaNews',
    VIDEO: 'siteAreaVideo',
    COCKPIT: 'siteAreaCockpit',
    PROFILE: 'siteAreaProfile',
    LIFESTYLE: 'siteAreaLifestyle'
} as const;

/**
 * All site area names
 */
export const SiteAreaName = {
    [SiteArea.NEWS]: 'News',
    [SiteArea.VIDEO]: 'Video',
    [SiteArea.COCKPIT]: 'Cockpit',
    [SiteArea.PROFILE]: 'Profil',
    [SiteArea.LIFESTYLE]: 'Lifestyle'
} as const;

/**
 * All site area theme colors
 */
export const SiteAreaTheme = {
    [SiteArea.NEWS]: styleConfig.colorSapphire,
    [SiteArea.VIDEO]: styleConfig.colorRegalBlue,
    [SiteArea.COCKPIT]: styleConfig.colorSapphire,
    [SiteArea.PROFILE]: styleConfig.colorSapphire,
    [SiteArea.LIFESTYLE]: styleConfig.colorSapphire
} as const;
